import {Dialog} from '@headlessui/react'
import {AnimatePresence} from 'framer-motion'

import {noop, twMerge} from '@sdox/utils'

import {Backdrop} from './parts/Backdrop'
import {Panel} from './parts/Panel'
import {Header} from './parts/Header'
import {Content} from './parts/Content'
import {useCloseDialogOnBrowserBack} from '../../hooks/useCloseDialogOnBrowserBack'

import type {PanelProps} from './parts/Panel'
import type {ReactNode} from 'react'
import type {DialogProps} from '@headlessui/react'

export type SidePanelRootProps = DialogProps & {
  children: ReactNode
  className?: string
  heading?: ReactNode
  persistent?: boolean
  size?: PanelProps['size']
  closeOnBrowserBack?: boolean
}

export const SidePanelRoot = ({
  open,
  children,
  className,
  heading,
  onClose,
  persistent,
  size,
  closeOnBrowserBack = true,
  ...restProps
}: SidePanelRootProps) => {

  useCloseDialogOnBrowserBack({onClose, closeOnBrowserBack, open})

  return (
    <AnimatePresence>
      {open && (
        <Dialog
          open={open}
          onClose={persistent ? noop : onClose}
          className={twMerge('fixed inset-0 z-[100] overflow-hidden', className)}
          {...restProps}
        >
          <Backdrop />
          <Panel size={size}>
            <Header
              heading={heading}
              showCloseButton={!persistent}
            />
            <Content>{children}</Content>
          </Panel>
        </Dialog>
      )}
    </AnimatePresence>
  )
}
